const actions = {
  listarPosicoes: async (context, { vendor_id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/estoque-por-localizacao/localizacao`, {
      params: {
        per_page: 100,
        vendor_id,
      },
    });

    return response;
  },
  criarPosicao: async (context, { nome, vendor_id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.post(`/estoque-por-localizacao/localizacao`, {
      vendor_id,
      nome,
    });

    return response;
  },
  deletarPosicao: async (context, { id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.delete(
      `/estoque-por-localizacao/localizacao/${id}`
    );

    return response;
  },
  upload: async (context, { planilha, mapeamento, adicional }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.post(`/manutencao-planilha`, {
      planilha,
      mapeamento,
      adicional,
    });

    return response;
  },
  getProdutos: async (
    context,
    { vendor_id, localizacao, produto, perPage, page }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/estoque-por-localizacao`, {
      params: {
        per_page: perPage,
        page,
        vendor_id,
        localizacao,
        produto,
      },
    });

    return response;
  },
  localizacao: async (context, { vendor_id, nome }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/estoque-por-localizacao/localizacao`, {
      params: {
        per_page: 1000,
        vendor_id,
        nome,
      },
    });

    return response;
  },
  movimentar: async (context, { produtos }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.post(`/estoque-por-localizacao`, {
      produtos,
    });

    return response;
  },
  listarEstoqueConsolidado: async (context, params) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/products/estoque-consolidado`, {
      params,
    });

    return response;
  },
  exportarEstoqueConsolidado: async (context, params) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/products/estoque-consolidado`, {
      params,
      responseType: "blob",
    });

    return response;
  },
};

export const estoque = {
  namespaced: true,
  actions,
};
